import { StickerGridTemplateFactory } from './StickerGridTemplateFactory';

export class StickerGridTemplateLV4731 extends StickerGridTemplateFactory {
  constructor(emptyStickers) {
    super(
      emptyStickers,
      7,
      27,
      {
        top: 13.5,
        left: 9.9,
      },
      {
        external: {
          horizontal: 2.5,
          vertical: 0,
        },
        internal: {
          qrLeft: 1,
          qrRight: 0,
          qrTop: 1,
          qrBot: 1,
          label: 1,
          labelTop: 0.5,
        },
      },
      {
        qr: 8,
        labelV: 7.6,
        labelH: 14.4,
        font: 5,
      },
      {
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      }
    );
  }

  getStickerTotalXSize =
    this.pad.internal.qrLeft +
    this.size.qr +
    this.pad.internal.qrRight +
    this.pad.internal.label +
    this.size.labelH +
    this.pad.internal.label;

  getStickerTotalYSize = this.pad.internal.qrTop + this.size.qr + this.pad.internal.qrBot;

  static getConstructorFunction = emptyStickers => new StickerGridTemplateLV4731(emptyStickers);
}
